module.exports = __webpack_public_path__ + "static/media/5.7446d1e7.png";